export const colors = {
  // Brand colors
  orange: '#FF9F1C',
  orangeHover: '#E68A00',
  white: '#FFFFFF',
  black: '#141414',
  gray: '#8A8B90',
  green: '#7bbb3e',
  sadgreen: '#3E7C48',
  softgray: '#e9edf5',
  midgray: '#595959',
  darkgray: '#444444',
  red: '#cc0000',
  warning: '#ffc300',
  blue: '#0F617D',
  darkblue: '#113a47',
  sadblue: '#3E5180',
  amber: '#FFA000',
  darkamber: '#f4c42e',
  
  // Neutral palette - Modern 2026 design system
  neutral: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  
  // Semantic colors
  success: {
    light: '#DCFCE7',
    DEFAULT: '#22C55E',
    dark: '#166534',
  },
  error: {
    light: '#FEE2E2',
    DEFAULT: '#EF4444',
    dark: '#991B1B',
  },
  info: {
    light: '#DBEAFE',
    DEFAULT: '#3B82F6',
    dark: '#1E40AF',
  },
  warningPalette: {
    light: '#FEF3C7',
    DEFAULT: '#F59E0B',
    dark: '#92400E',
  },
}

// Shadow system - Subtle depth tokens
export const shadows = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  DEFAULT: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  focusOrange: '0 0 0 3px rgba(255, 159, 28, 0.3)',
  cardHover: '0 10px 20px -5px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.05)',
}
